<h2 mat-dialog-title>{{ data.header }}</h2>

<ng-scrollbar mat-dialog-content [autoHeightDisabled]="false">
  <div class="scroll-bar-margin">
    <ng-container *ngTemplateOutlet="data.template; context: { $implicit: clickClose }"></ng-container>
  </div>
  <p class="confirm-delete">
    <b>This action is permanent and cannot be undone.</b>
    If you are sure, please type "DELETE" in the field below.
  </p>
  <mat-form-field appearance="outline" class="delete-input">
    <input data-testid="confirm-delete" matInput type="text" [(ngModel)]="textMatcherValue" />
  </mat-form-field>
</ng-scrollbar>

<div mat-dialog-actions>
  <button
    [disabled]="isDeleteButtonDisabled()"
    color="warn"
    (click)="clickClose(deleteDialogAction.Delete)"
    mat-flat-button
  >
    {{ data.deleteText }}
  </button>
  <button *ngIf="data.secondaryText" color="primary" (click)="clickClose(deleteDialogAction.Secondary)" mat-flat-button>
    {{ data.secondaryText }}
  </button>
  <button mat-stroked-button *ngIf="data.noText" (click)="clickClose(deleteDialogAction.Cancel)">
    {{ data.noText }}
  </button>
</div>
